export class DrawerHeaderItem {
    label: string;
    name: string;
    toggle: boolean;
    required: boolean;
    parent?: string;
    type: string;
}